import axios from "axios";
import apisUrl from "./apiUrls";

export const postThirdPartyRequest = async (
  fullName,
  email,
  appName,
  companyName,
  grantType,
  redirectUris,
) => {
  const data = {
    firstName: fullName,
    email: email,
    appName: appName,
    companyName: companyName,
    grantType: grantType,
    redirectUrl: redirectUris,
  };
  const url = apisUrl.baseUrl + apisUrl.requestAccessUrl;
  const response = await axios.post(url, data).catch((err) => {
    return err;
  });
  return response;
};
